import styled from '@emotion/styled';

import { screen } from '@/components/common/breakpoints';
import { Button } from '@/components/common/Buttons';
import { PostTableOfContents } from '@/components/page/blog/PostTableOfContents';

import type { SanityBlogPostTocDataType } from '@/components/page/blog/PostTableOfContents';

export interface PostSidebarProps {
  tocData: SanityBlogPostTocDataType;
}

export const PostSidebar = ({ tocData }: PostSidebarProps) => {
  return (
    <ContentsContainer>
      <Button
        variant="solid-light"
        href="/blog"
        iconPosition="left"
        icon="ArrowLeft"
      >
        See all posts
      </Button>

      {!!tocData.count && <PostTableOfContents tocData={tocData} />}
    </ContentsContainer>
  );
};

const ContentsContainer = styled.div`
  ${screen.md} {
    top: calc(var(--full-navbar-height) + var(--spacing-large));
    position: sticky;

    height: fit-content;
    min-width: 300px;
  }
`;
